import { render, staticRenderFns } from "./moments.vue?vue&type=template&id=5d833d2e&lang=pug"
import script from "./moments.vue?vue&type=script&lang=js"
export * from "./moments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports